import { ReactNode, useCallback, useState } from "react";
import clsx from "clsx";

type Props = {
  content: ReactNode;
  position?: "left" | "right" | "top" | "bottom";
  center?: boolean;
  children: ReactNode;
  className?: string;
  tooltipClassName?: string;
};

export default function Tooltip({
  content,
  position,
  center = false,
  tooltipClassName,
  className,
  children,
}: Props) {
  const [showTooltip, setShowTooltip] = useState(false);

  const showHandler = useCallback(() => {
    setShowTooltip(true);
  }, []);

  const hideHandler = useCallback(() => {
    setShowTooltip(false);
  }, []);

  return (
    <div
      className={clsx("relative", className)}
      onMouseOver={showHandler}
      onMouseLeave={hideHandler}
    >
      {showTooltip && (
        <div
          className={clsx(
            "absolute",
            {
              "right-[100%] mr-2": position === "left",
              "left-[100%] ml-2": position === "right",
              "top-[50%] -translate-y-[50%]":
                center && (position === "left" || position === "right"),
              "bottom-[100%] mb-2": position === "top",
              "top-[100%] mt-2": position === "bottom",
              "left-[50%] -translate-x-[50%]":
                center && (position === "top" || position === "bottom"),
            },
            tooltipClassName,
          )}
        >
          {content}
        </div>
      )}
      {children}
    </div>
  );
}
